import React, { useMemo, useState } from "react";
import styled, { css } from "styled-components";

/**
 * NOTE:
 * - This file assumes your existing member images are already correct.
 * - New Excel-added contributors use initials fallback (no img).
 */

import Img1 from "../Assests/perin.png";
import Img2 from "../Assests/cardana.png";
import Img3 from "../Assests/gumanoy.png";
import Img4 from "../Assests/Malarejes.png";
import Img5 from "../Assests/mercado.gif";
import Img6 from "../Assests/pabalate.png";
import Img7 from "../Assests/J.jpg";
import Img8 from "../Assests/download.jpg";
import Img9 from "../Assests/rr.jpg";
import Img10 from "../Assests/gera.png";
import Img11 from "../Assests/DEXTER.png";
import Img12 from "../Assests/Gerald.png";
import Img13 from "../Assests/Angel.png";
import Img14 from "../Assests/Inte.png";
import Img15 from "../Assests/Cadenas.png";
import Img16 from "../Assests/Esto.png";
import Img17 from "../Assests/Betarmos.png";
import Img18 from "../Assests/Madijanon.png";
import Img19 from "../Assests/Peresores.png";
import Img20 from "../Assests/AncogE.png";
import Img21 from "../Assests/Garay.png";
import Img22 from "../Assests/Kirby.png";
import Img23 from "../Assests/Jaya.png";
import Img24 from "../Assests/Tuba.png";
import Img25 from "../Assests/Lagura.png";
import Img26 from "../Assests/Arong.png";
import Img27 from "../Assests/Manla.png";
import Img28 from "../Assests/Gumapac.png";
import Img29 from "../Assests/Jesila.png";
import Img30 from "../Assests/Paas.png";
import Img31 from "../Assests/Queta.png";
import Img32 from "../Assests/Sagosoy.png";
import Img33 from "../Assests/Hingpit.png";
import Img34 from "../Assests/Labonite.png";
import Img35 from "../Assests/ChiquitoKC.png";
import Img36 from "../Assests/PaasJV.png";
import Img37 from "../Assests/Cartaginas.png";
import Img38 from "../Assests/balio.png";

/* ---------- Glass tokens (maroon/gold) ---------- */
const glass = css`
  backdrop-filter: blur(26px) saturate(175%) brightness(1.03);
  -webkit-backdrop-filter: blur(26px) saturate(175%) brightness(1.03);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.04)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.55), rgba(255,255,255,0.18), rgba(139,29,29,0.16)) border-box;

  box-shadow:
    0 18px 55px rgba(0,0,0,0.12),
    inset 0 1px 0 rgba(255,255,255,0.35);
`;

const glassSoft = css`
  backdrop-filter: blur(18px) saturate(165%) brightness(1.02);
  -webkit-backdrop-filter: blur(18px) saturate(165%) brightness(1.02);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.03)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.45), rgba(255,255,255,0.16), rgba(139,29,29,0.14)) border-box;

  box-shadow:
    0 14px 45px rgba(0,0,0,0.10),
    inset 0 1px 0 rgba(255,255,255,0.28);
`;

const LATEST_PHASE = 6;

/**
 * Phase 3–4 contribution metadata extracted from your Excel.
 * Only keep: group, track, task (for uniform display)
 * Keyed by LAST NAME in lowercase.
 */
const EXCEL_PHASE_34 = {
  ancog: {
    phases: [3, 4,],
    phase3: { group: 2, track: "Web-Frontend", task: "Documentator" },
    phase4: { group: 2, track: "Web-Frontend", task: "Documentator" },
    phase6: { group: 2, track: "Web-Frontend", task: "Documentator" },
  },
  boco: {
    phases: [3, 4],
    phase3: { group: 1, track: "Web-Frontend", task: "Documentator" },
    phase4: { group: 1, track: "Web-Frontend", task: "Documentator" },
  },
  cadenas: {
    phases: [3, 4],
    phase3: { group: 5, track: "Web-Frontend", task: "Analyst" },
    phase4: { group: 5, track: "Web-Frontend", task: "Analyst" },
  },
  chiquito: {
    phases: [3, 4],
    phase3: { group: 5, track: "Web-Frontend", task: "Documentator" },
    phase4: { group: 5, track: "Web-Frontend", task: "Documentator" },
  },
  cutora: {
    phases: [3, 4],
    phase3: { group: 2, track: "Mobile", task: "Lead Programmer" },
    phase4: { group: 2, track: "Mobile", task: "Lead Programmer" },
    phase5: { group: 5, track: "Web-Frontend", task: "Analyst" },
  },
  dacoylo: {
    phases: [3, 4, 5],
    phase3: { group: 5, track: "Mobile", task: "Documentator" },
    phase4: { group: 5, track: "Mobile", task: "Documentator" },
    phase5: { group: 5, track: "Web-Frontend", task: "Documentator" },
  },
  esto: {
    phases: [3, 4],
    phase3: { group: 4, track: "Web-Backend", task: "Lead Programmer" },
    phase4: { group: 4, track: "Web-Backend", task: "Lead Programmer" },
  },
  hingpit: {
    phases: [4,5,6],
    phase4: { group: 4, track: "Web-Backend", task: "Documentator" },
    phase5: { group: 4, track: "Web-Backend", task: "Documentator" },
    phase6: { group: 4, track: "Web-Backend", task: "Documentator" },
  },
  gera: {
    phases: [3, 4],
    phase3: { group: 1, track: "Mobile", task: "Documentator" },
    phase4: { group: 1, track: "Mobile", task: "Documentator" },
  },
  inte: {
    phases: [3, 5, 6],
    phase3: { group: 3, track: "Web-Backend", task: "Analyst" },
    phase5: { group: 3, track: "Web-Backend", task: "Analyst" },
    phase6: { group: 3, track: "Web-Backend", task: "Analyst" },
  },
  organiza: {
    phases: [3, 4, 5, 6],
    phase3: { group: 5, track: "Web-Backend", task: "Lead Programmer" },
    phase4: { group: 5, track: "Web-Backend", task: "Lead Programmer" },
    phase5: { group: 5, track: "Web-Backend", task: "Lead Programmer" },
    phase6: { group: 5, track: "Web-Backend", task: "Lead Programmer" },
  },
  perater: {
    phases: [3, 4],
    phase3: { group: 3, track: "Web-Frontend", task: "Analyst" },
    phase4: { group: 3, track: "Web-Frontend", task: "Analyst" },
  },
  tiongco: {
    phases: [3],
    phase3: { group: 2, track: "Web-Backend", task: "Documentator" },
  },
    betarmos: {
    phases: [3],
    phase3: { group: 4, track: "Web-Frontend", task: "Lead Programmer" },
  },
  manla: {
    phases: [3],
    phase3: { group: 4, track: "Web-Frontend", task: "Documentator" },
  },
  gumapac: {
    phases: [3],
    phase3: { group: 4, track: "Web-Frontend", task: "Lead Analyst" },
  },
    garay: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Lead Programmer" },
  },
    arong: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Documentator" },
  },
    tuba: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Analyst" },
  },
    peresores: {
    phases: [3],
    phase3: { group: 3, track: "Web-Frontend", task: "Lead Programmer" },
  },
    madijanon: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Documentator" },
  },
    lagura: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Analyst" },
  },
    jaya: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Lead Programmer" },
  },
    diliman: {
    phases: [3],
    phase3: { group: 1, track: "Web-Frontend", task: "Documentator" },
  },
    ancogE: {
    phases: [3, 5, 6],
    phase3: { group: 1, track: "Web-Frontend", task: "Analyst" },
    phase5: { group: 1, track: "Web-Frontend", task: "Analyst" },
    phase6: { group: 1, track: "Web-Frontend", task: "Documentator" },
  },
    tanio: {
    phases: [5],
    phase5: { group: 1, track: "Web-Frontend", task: "Lead Programmer" },
  },
  labonite: {
    phases: [5],
    phase5: { group: 1, track: "Web-Backend", task: "Lead Programmer" },
  },
  paasa: {
    phases: [5],
    phase5: { group: 1, track: "Web-Backend", task: "Documentator" },
  },
  sagosoy: {
    phases: [5],
    phase5: { group: 1, track: "Web-Backend", task: "Analyst" },
  },
  quieta: {
    phases: [5],
    phase5: { group: 1, track: "Web-Backend", task: "Lead Programmer" },
  },
valentos: {
    phases: [5],
    phase5: { group: 1, track: "Web-Backend", task: "Documentator" },
  },
  chiquitokenn: {
    phases: [6],
    phase6: { group: 1, track: "Web-Backend", task: "Lead Programmer" },
  },
  paas: {
    phases: [6],
    phase6: { group: 1, track: "Web-Backend", task: "Documentator" },
  },
  cartaginas: {
    phases: [6],
    phase6: { group: 1, track: "Web-Backend", task: "Lead Programmer" },
  },
    balio: {
    phases: [6],
    phase6: { group: 1, track: "Web-Backend", task: "Documentator" },
  },

};

const PHASE_OPTIONS = [
  { value: "all", label: "All phases" },
  { value: 6, label: "Phase 6 (Latest)" },
  { value: 5, label: "Phase 5" },
  { value: 4, label: "Phase 4" },
  { value: 3, label: "Phase 3" },
  { value: 2, label: "Phase 2" },
  { value: 1, label: "Phase 1" },
];

/* ---------- Helpers ---------- */
const normalizeLastNameKey = (fullName = "") => {
  const cleaned = String(fullName)
    .trim()
    .replace(/[^\p{L}\p{N}\s.]/gu, " ")
    .replace(/\s+/g, " ");
  const parts = cleaned.split(" ").filter(Boolean);
  const last = (parts[parts.length - 1] || "").toLowerCase();

  // Excel has "Cutora" but your existing record is "Cutura"
  if (last === "cutura") return "cutora";
  return last;
};

const getInitials = (fullName = "") => {
  const cleaned = String(fullName)
    .trim()
    .replace(/[^\p{L}\s]/gu, " ")
    .replace(/\s+/g, " ");
  const parts = cleaned.split(" ").filter(Boolean);
  if (!parts.length) return "?";
  const first = parts[0]?.[0] || "";
  const last = parts[parts.length - 1]?.[0] || "";
  return (first + last).toUpperCase();
};

const excelNameToDisplay = (raw = "") => {
  // "Last, First Middle" => "FIRST MIDDLE LAST" uppercase
  const s = String(raw).trim();
  if (!s.includes(",")) return s.toUpperCase();
  const [last, first] = s.split(",").map((x) => x.trim());
  return `${first} ${last}`.trim().toUpperCase();
};

/**
 * Uniform display: NO rating, NO feature.
 * Keep: Phase, Group, Track, Task
 */
const formatContribution = (phase, rec) => {
  if (!rec) return null;
  return `Phase ${phase} • G${rec.group} • ${rec.track} • ${rec.task}`;
};

/* ---------- Base team members (existing) ---------- */
const BASE_TEAM = [
  { name: "MAX ANGELO D. PERIN", title: "Co-Founder / Senior Fullstack Developer", img: Img1, phases: [1, 2, 3, 4, 5, 6], priority: 1 },
  { name: "DARREL A. CARDAÑA", title: "Co-Founder / Data Analyst", img: Img2, phases: [1, 2, 3, 4, 5, 6], priority: 2 },
  { name: "CECILIA T. GUMANOY", title: "Co-Founder / Business Analyst", img: Img3, phases: [1, 2, 3, 4, 5, 6], priority: 3 },

  { name: "JOHN STEPHEN B. MALAREJES", title: "Web Developer", img: Img4, phases: [2, 3], priority: 10 },
  { name: "MARCO PIOLO P. MERCADO", title: "Server Developer", img: Img5, phases: [2, 3], priority: 11 },
  { name: "ROCKY M. PABALATE", title: "Mobile Developer", img: Img6, phases: [2, 3], priority: 12 },
  { name: "JEANY BABE G. PAILANAN", title: "Lead Programmer", img: Img7, phases: [3], priority: 13 },

  { name: "EDEN PEARL F. CUTURA", title: "Mobile Programmer", img: Img8, phases: [3, 4, 5], priority: 20 },
  { name: "ELVIN M. PERATER", title: "Web Programmer", img: Img9, phases: [3, 4], priority: 21 },
  { name: "ANGELA L. GERA", title: "Documentator", img: Img10, phases: [3, 4], priority: 22 },
  { name: "DEXTER C. ORGANIZA", title: "Web Programmer", img: Img11, phases: [3, 4, 5, 6], priority: 23 },
  { name: "ANGEL DIANE O. DACOYLO", title: "Contributor", img: Img13, phases: [3, 4, 5], priority: 25 },
  { name: "GLORY GRACE INTE", title: "Analyst", img: Img14, phases: [3, 5, 6], priority: 26 },
  { name: "MARY GRACE CADENAS", title: "Analyst", img: Img15, phases: [3, 4], priority: 27 },
  { name: "KEVIN D. ESTO", title: "UI Designer", img: Img16, phases: [3, 4], priority: 28 },
  { name: "ELLA MAE S. ANCOG", title: "Documentator", img: Img20, phases: [3, 4, 5, 6], priority: 30 },
  { name: "KENN COLLIN T. CHIQUITO", title: "Lead Programmer", img: Img35, phases: [6], priority: 31 },
  { name: "JOHN VINCENT PAAS", title: "Documentator", img: Img36, phases: [6], priority: 32 },
  { name: "JHON REY CARTAGINAS", title: "Lead Programmer", img: Img37, phases: [6], priority: 33 },
  { name: "MERCYDETHA BALIO", title: "Documentator", img: Img38, phases: [6], priority: 34 },
];

/* ---------- Excel-added members not in BASE_TEAM ---------- */
const EXTRA_FROM_EXCEL = [
  { raw: "Ancog, Noel" },
  { raw: "Boco, Joana" },
  { raw: "Cadenas, Mary Grace" },
  { raw: "Chiquito, Kirby Ceasar", img: Img22 },
  { raw: "Tanio, Gerald P.", img: Img12 },
  { raw: "Esto, Kevin" },
  { raw: "Tiongco, Ralph" },
  { raw: "Arong, Ara Jane", img: Img26 },
  { raw: "Tuba, Cj", img: Img24 },
  { raw: "Lagura, Aileen", img: Img25 },
  { raw: "Jaya, Jhon Ernest", img: Img23 },
  { raw: "Peresores, Jeffrey", img: Img19 },
  { raw: "Madijanon, Jade", img: Img18 },
  { raw: "Betarmos, James Paolo", img: Img17 },
  { raw: "Manla, Mark", img: Img27 },
  { raw: "Gumapac, Melva", img: Img28 },
  { raw: "Garay, Garlyn Gail", img: Img21 },
  { raw: "Hingpit, Gerald", img: Img33 },
  { raw: "Labonite, Jhell Jone R.", img: Img34 },
  { raw: "Sagosoy, Mary Rose Shary N.", img: Img32 },
  { raw: "Paasa, Emmanuel Kent P.", img: Img30 },
  { raw: "Quieta, Clark Jay G.", img: Img31 },
  { raw: "Valentos, Jesila G.", img: Img29 },
];

const buildTeam = () => {
  const baseLastKeys = new Set(BASE_TEAM.map((m) => normalizeLastNameKey(m.name)));

  // Enrich base team with Excel data if available
  const enrichedBase = BASE_TEAM.map((m) => {
    const key = normalizeLastNameKey(m.name);
    const excel = EXCEL_PHASE_34[key];

    if (!excel) return { ...m, contributionP4: null, contributionP3: null, contributionP5: null, contributionP6: null };

    const phases = Array.from(new Set([...(m.phases || []), ...(excel.phases || [])])).sort((a, b) => a - b);
    return {
      ...m,
      phases,
      contributionP6: formatContribution(6, excel.phase6),
      contributionP5: formatContribution(5, excel.phase5),
      contributionP4: formatContribution(4, excel.phase4),
      contributionP3: formatContribution(3, excel.phase3),
    };
  });

  // Add extra members from Excel (initials fallback)
  const extras = EXTRA_FROM_EXCEL
    .map((x) => {
      const displayName = excelNameToDisplay(x.raw);
      const key = normalizeLastNameKey(displayName);
      if (baseLastKeys.has(key)) return null;

      const excel = EXCEL_PHASE_34[key];
      const latest = excel?.phase6;
      const derivedTitle = latest ? `${latest.track} • ${latest.task}` : "Contributor";

      return {
        name: displayName,
        title: derivedTitle,
        img: x.img || null,
        phases: excel?.phases || [3, 4, 5, 6],
        contributionP6: formatContribution(6, excel?.phase6),
        contributionP5: formatContribution(5, excel?.phase5),
        contributionP4: formatContribution(4, excel?.phase4),
        contributionP3: formatContribution(3, excel?.phase3),
        priority: 40,
      };
    })
    .filter(Boolean);

  return [...enrichedBase, ...extras].sort((a, b) => {
    const pa = a.priority ?? 999;
    const pb = b.priority ?? 999;
    if (pa !== pb) return pa - pb;
    return String(a.name).localeCompare(String(b.name));
  });
};

const TEAM = buildTeam();

/* ---------- Component ---------- */
const TeamMembers = () => {
  const [phaseFilter, setPhaseFilter] = useState(LATEST_PHASE);

  const filtered = useMemo(() => {
    if (phaseFilter === "all") return TEAM;
    return TEAM.filter((m) => (m.phases || []).includes(Number(phaseFilter)));
  }, [phaseFilter]);

  return (
    <Container id="team">
      <Header>
        <Title>OUR TEAM MEMBERS</Title>
            <div>
              <strong>Developed by:</strong> ᜉᜈᜈᜎᜒᜃ᜔ᜐᜒᜃᜈ᜔ ᜅ᜔ ᜋᜃᜐ x Full Stack Masters, Computing Society,
              Computer Science Department, Bohol Island State University – Bilar Campus 2024-Present
            </div>
            <div>
              <strong>For instruction:</strong> Data Structures and Algorithms; Information Management; Complexity
              of Algorithms; Web Development and Enterprises; Mobile Development; Intelligent Systems
            </div>
        <Toolbar>
          <ControlGroup>
            <Label htmlFor="phaseFilter">Phase</Label>
            <Select
              id="phaseFilter"
              value={phaseFilter}
              onChange={(e) => {
                const v = e.target.value;
                setPhaseFilter(v === "all" ? "all" : Number(v));
              }}
            >
              {PHASE_OPTIONS.map((opt) => (
                <option key={String(opt.value)} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Select>
          </ControlGroup>

          <Hint>
            Default view is <strong>Phase 6</strong>. Switch phases to see earlier contributors.
          </Hint>
        </Toolbar>
      </Header>

      <Members>
        {filtered.map((member, idx) => (
          <Member key={`${member.name}-${idx}`}>
            <ImageContainer>
              {member.img ? (
                <>
                  <Image src={member.img} alt={member.name} />
                  <Overlay />
                </>
              ) : (
                <FallbackAvatar aria-label={`${member.name} avatar`}>
                  <span>{getInitials(member.name)}</span>
                </FallbackAvatar>
              )}
            </ImageContainer>

            <NamePill>
              <Name>{member.name}</Name>
            </NamePill>

            <Role>{member.title}</Role>

            {(member.contributionP4 || member.contributionP3 || member.contributionP5 || member.contributionP6) && (
              <Contribution>
                {member.contributionP4 && <div>{member.contributionP4}</div>}
                {member.contributionP3 && <div className="muted">{member.contributionP3}</div>}
                {member.contributionP5 && <div className="muted">{member.contributionP5}</div>}
                {member.contributionP6 && <div className="muted">{member.contributionP6}</div>}
              </Contribution>
            )}
          </Member>
        ))}
      </Members>
    </Container>
  );
};

export default TeamMembers;

/* ---------- Styles ---------- */
const Container = styled.section`
  text-align: center;
  padding: 5.5rem 1rem 4rem;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: transparent;

  /* subtle brand blobs to help glass read */
  &::before {
    content: "";
    position: absolute;
    width: 820px;
    height: 820px;
    left: -360px;
    top: 120px;
    background: radial-gradient(circle at 35% 35%, rgba(139,29,29,0.16), transparent 62%);
    filter: blur(80px);
    opacity: 0.9;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    width: 860px;
    height: 860px;
    right: -380px;
    bottom: -380px;
    background: radial-gradient(circle at 40% 40%, rgba(246,201,69,0.14), transparent 62%);
    filter: blur(90px);
    opacity: 0.9;
    pointer-events: none;
  }
`;

const Header = styled.div`
  position: relative;
  z-index: 1;
  margin-bottom: 2.2rem;
`;

const Title = styled.h2`
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 1000;
  font-size: clamp(2rem, 3.2vw, 2.6rem);
  color: #8b1d1d;
  letter-spacing: -0.02em;
`;

const Toolbar = styled.div`
  margin: 1.35rem auto 0;
  max-width: 1120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
`;

const ControlGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Label = styled.label`
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  color: rgba(139, 29, 29, 0.95);
`;

const Select = styled.select`
  ${glassSoft}
  border-radius: 14px;
  padding: 0.65rem 0.85rem;
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  color: rgba(32, 21, 21, 0.9);
  outline: none;
  cursor: pointer;

  option {
    color: #111;
  }
`;

const Hint = styled.div`
  ${glassSoft}
  border-radius: 14px;
  padding: 0.65rem 0.85rem;
  font-family: "Poppins", sans-serif;
  color: rgba(32, 21, 21, 0.72);
  font-size: 0.95rem;

  strong {
    color: rgba(139, 29, 29, 0.95);
  }
`;

const Members = styled.div`
  position: relative;
  z-index: 1;

  display: grid;
  grid-template-columns: repeat(3, minmax(240px, 1fr));
  gap: clamp(50px, 50px, 50px);
  padding: 0 clamp(8px, 3vw, 25px);
  max-width: 1520px;
  margin: 0 auto;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(240px, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Member = styled.div`
  ${glass}
  position: relative;
  text-align: center;
  border-radius: 22px;
  padding: 18px 18px 16px;
  width: 100%;
  transition: transform 0.18s ease, filter 0.18s ease, box-shadow 0.18s ease;

  &:hover {
    transform: translateY(-6px);
    filter: brightness(1.03);
    box-shadow:
      0 24px 70px rgba(0,0,0,0.14),
      inset 0 1px 0 rgba(255,255,255,0.38);
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 999px;
  overflow: hidden;
  margin: 18px auto 0;

  border: 3px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.02)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.85), rgba(139,29,29,0.30)) border-box;

  box-shadow:
    0 16px 40px rgba(0,0,0,0.12),
    inset 0 1px 0 rgba(255,255,255,0.30);

  transition: transform 0.18s ease;

  ${Member}:hover & {
    transform: scale(1.02);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const FallbackAvatar = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at 30% 25%, rgba(246,201,69,0.35), rgba(139,29,29,0.22), rgba(255,255,255,0.06));
  color: rgba(32, 21, 21, 0.9);

  span {
    font-family: "Poppins", sans-serif;
    font-weight: 1000;
    font-size: 2.2rem;
    letter-spacing: 0.02em;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(139, 29, 29, 0.35),
    rgba(246, 201, 69, 0.08),
    transparent
  );
  opacity: 0;
  transition: opacity 0.2s ease;

  ${Member}:hover & {
    opacity: 1;
  }
`;

const NamePill = styled.div`
  ${glassSoft}
  margin: 16px auto 0;
  border-radius: 999px;
  padding: 0.62rem 0.95rem;
  display: inline-block;
`;

const Name = styled.h3`
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.92rem;
  color: rgba(32, 21, 21, 0.92);
  font-weight: 950;
  letter-spacing: 0.01em;
`;

const Role = styled.p`
  margin: 10px 0 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.9rem;
  color: rgba(32, 21, 21, 0.72);
  font-weight: 700;
`;

const Contribution = styled.div`
  ${glassSoft}
  margin: 12px auto 0;
  padding: 10px 12px;
  border-radius: 14px;
  width: 100%;
  max-width: 92%;
  text-align: left;

  max-height: 76px;
  overflow: auto;

  color: rgba(32, 21, 21, 0.78);
  font-family: "Poppins", sans-serif;
  font-size: 0.82rem;
  line-height: 1.35;

  div {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    display: block;
    margin: 0;
  }

  .muted {
    color: rgba(32, 21, 21, 0.62);
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(32, 21, 21, 0.10);
  }

  scrollbar-width: thin;
  scrollbar-color: rgba(139, 29, 29, 0.35) transparent;

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(139, 29, 29, 0.28);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;
